import { getLocale } from "../runtime";

const sv_step = /** @type {(inputs: {value: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Steg ${inputs.value}`
};

const step = /** @type {(inputs: {value: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_step(inputs)
	return "step";
};

export { step as "step" };